import UserRoleActionTypes from './UserRoleActionTypes';
import UserRoleDispatcher from './UserRoleDispatcher';

const Actions = {
  addUserRole(newRole) {
    UserRoleDispatcher.dispatch({
      type: UserRoleActionTypes.ADD_USER_ROLE,
      newRole,
    });
  },

  updateUserRole(roleKey, newAttrs) {
    UserRoleDispatcher.dispatch({
      type: UserRoleActionTypes.UPDATE_USER_ROLE,
      roleKey,
      newAttrs,
    });
  },

  deleteUserRole(roleKey) {
    UserRoleDispatcher.dispatch({
      type: UserRoleActionTypes.DELETE_USER_ROLE,
      roleKey
    });
  }
};

export default Actions;


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/actions/UserRoleActions.js